import * as React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Autocomplete,
} from "@mui/material";

import { useForm, Controller } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getHubName, getVendorsList, vehiclesDetails } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import { useEffect } from "react";
import toast from "react-hot-toast";

export default function Addneworder({ setActiveItem }) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const cities = useSelector((state) => state?.cities?.citiesData);
  const isSystemUserList = useSelector(
    (state) => state?.isSystemUser?.isSysTemUserData?.entities?.rows,
  );
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const vehicleBlockType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBlockType;

  const [activeStep, setActiveStep] = useState(0);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [hubs, setHubs] = useState(null);
  const [vehicleList, setVehicleList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const workorderType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderType;
  delete workorderType?.inverted;
  const helpdeskTicketPriority = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.helpdeskTicketPriority;
  delete helpdeskTicketPriority?.inverted;
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  delete workorderStatus?.inverted;
  const workorderStatus2 = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [workOrderReponse, setWorkOrderResponse] = useState(null);
  const [formData, setFormData] = useState({});
  const [blockFormData, setBlockFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [bookingsOnBlock, setBookingsOnBlock] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const catalogRoles = JSON.parse(localStorage.getItem("catalogValues"))?.role
    ?.inverted?.franchiseAdmin;
  const catalogRActions = JSON.parse(localStorage.getItem("catalogValues"))
    ?.action?.inverted?.viewMyCityBookings;

  const isRestrictedCityUser =
    profile?.roles?.includes(Number(catalogRoles)) ||
    profile?.actions?.includes(Number(catalogRActions));

  useEffect(() => {
    if (blockFormData?.endTime) {
      getBookingOnBlock();
    }
  }, [blockFormData?.endTime]);

  const getBookingOnBlock = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/bookings/getbookingbydates?startDate=${blockFormData?.startDate}T${blockFormData?.startTime}&endDate=${blockFormData?.endDate}T${blockFormData?.endTime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const filtered = data?.dataValues?.filter(
          (item) => String(item.vehicleId) === String(formData?.vehicle?.id),
        );
        setBookingsOnBlock(filtered);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const validateStep1 = () => {
    let errors = {};

    if (!formData.city) errors.city = "City is required";
    if (!formData.hub) errors.hub = "Hub is required";
    if (!formData.vehicle) errors.vehicle = "Vehicle is required";
    if (!formData.workordertype)
      errors.workordertype = "Workorder type required";
    // if (!formData.workorderstatus)
    //   errors.workorderstatus = "Workorder status required";
    // if (!formData.repairpriority) errors.repairpriority = "Priority required";
    // if (!formData.reportingdate)
    //   errors.reportingdate = "Reporting date required";
    // if (!formData.scheduleddate)
    //   errors.scheduleddate = "Scheduled date required";
    if (!formData.odometer) errors.odometer = "Odometer required";
    if (!formData.odometerimage)
      errors.odometerimage = "Odometer Image is required";
    // if (!formData.otherattachments)
    //   errors.otherattachments = "Attachments is required";

    return errors;
  };

  console.log("formData", formData)

  const validateStep2 = () => {
    let errors = {};

    if (!blockFormData.startDate) errors.startDate = "Start date required";
    if (!blockFormData.startTime) errors.startTime = "Start time required";
    if (!blockFormData.endDate) errors.endDate = "End date required";
    if (!blockFormData.endTime) errors.endTime = "End time required";

    // extra check
    if (
      blockFormData.startDate &&
      blockFormData.endDate &&
      blockFormData.startDate > blockFormData.endDate
    ) {
      errors.endDate = "End date must be after start date";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (activeStep === 0) {
      const validationErrors = validateStep1();

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        toast.error("Please fill all required fields");
        return;
      }

      const currentVehicle = vehicleList.find(
        (vehicle) => vehicle?.id === formData?.vehicle?.id,
      );

      if (
        currentVehicle &&
        Number(formData?.odometer) < Number(currentVehicle?.currentOdometer)
      ) {
        toast.error(
          "Odometer reading cannot be less than current vehicle odometer",
        );
        return;
      }

      setErrors({});
      setActiveStep((prev) => prev + 1);
      return;
    }

    // if (bookingsOnBlock.length > 0) {
    //   toast.error("Affected Bookings is there so cant able to block");
    //   return;
    // }

    const validationErrors = validateStep2();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill block details properly");
      return;
    }

    const currentVehicle = vehicleList.find(
      (vehicle) => vehicle?.id === formData?.vehicle?.id,
    );

    if (
      currentVehicle &&
      Number(formData?.odometer) < Number(currentVehicle?.currentOdometer)
    ) {
      toast.error(
        "Odometer reading cannot be less than current vehicle odometer",
      );
      return;
    }

    setErrors({});
    setIsSubmitting(true);

    try {
      const workOrderPayload = {
        vehicleId: formData?.vehicle?.id,
        name: currentVehicle?.name || null,
        licensePlate: formData?.vehicle?.vehcileNo,
        cityId: formData?.city,
        hubId: formData?.hub,
        serviceType: formData?.workordertype,
        odometerReading: Number(formData?.odometer),
        odometerImage: JSON.stringify(formData?.odometerimage),
        attachments: JSON.stringify(formData?.otherattachments),
        serviceStatus: workorderStatus2?.inverted?.open || null,
        subType : formData?.subWorkordertype || null
      };

      const response = await fetch(`${apiUrl}/api/vehicleservices`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(workOrderPayload),
      });
      const workOrderData = await response.json();

      if (workOrderData?.statusCode !== "0100") {
        toast.error(workOrderData?.msg || "Unable to create work order");
        return;
      }

      const createdOrder = workOrderData?.dataValues;
      const blockPayload = {
        vehicleId: createdOrder?.vehicleId,
        serviceLogId: createdOrder?.id,
        name: currentVehicle?.name || null,
        licensePlate: createdOrder?.licensePlate,
        initialOdometer: Number(currentVehicle?.currentOdometer || 0),
        comment: "Booked for workorder",
        blockType: vehicleBlockType?.inverted?.vehicleService,
        startDate: blockFormData?.startDate + "T" + blockFormData?.startTime,
        endDate: blockFormData?.endDate + "T" + blockFormData?.endTime,
        blockedBy: profile?.email,
        odometerImages: JSON.stringify(createdOrder?.odometerimage),
        attachments: JSON.stringify(createdOrder?.wororderImages),
      };

      const blockResponse = await fetch(`${apiUrl}/api/blockedvehicles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(blockPayload),
      });
      const blockData = await blockResponse.json();

      if (blockData?.statusCode !== "0100") {
        toast.error(blockData?.msg || "Unable to block vehicle");
        return;
      }

      setWorkOrderResponse(null);
      setActiveItem("Workorders Dashboard");
      setActiveStep(0);
      toast.success(
        "For new work order vehicle blocked successfully, you can check the details in the workorder dashboard",
        {
          position: "bottom-center",
          style: {
            background: "blue",
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        },
      );
      setFormData({});
      setBlockFormData({});
    } catch (error) {
      console.error(
        "Error submitting vehicle service and block payload:",
        error,
      );
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (isRestrictedCityUser && profile?.cityId) {
      setFormData((prev) => ({
        ...prev,
        city: profile.cityId,
        hub: profile?.hubId || (hubs && hubs[0]?.id),
      }));
    }
  }, [isRestrictedCityUser, profile?.cityId]);

  const ImageHandler = async (file) => {
    const res = await uploadmutiplefile(file, "vehicles", "vehicle");

    let filterImages = res?.uploaded?.map((image) => image?.url);

    setUploadedImages((prev) => {
      if (!prev || prev.length === 0) {
        return filterImages; // first upload
      }
      return [...prev, ...filterImages]; // append
    });

    return res; // ✅ THIS returns API response
  };

  const getHubAPI = async (cityId) => {
    const apiDetails = await getHubName(cityId);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows);
  };

  const getVehicleListingAPI = async (hubId) => {
    const apiDetails = await vehiclesDetails(hubId);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVehicleList(data?.entities?.rows);
  };

  const getVendorListAPI = async () => {
    const apiDetails = await getVendorsList();
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVendorList(data?.entities?.rows);
  };

  useEffect(() => {
    getVendorListAPI();
  }, []);

  useEffect(() => {
    if (formData?.hub) {
      getVehicleListingAPI(formData?.hub);
    }
  }, [formData?.hub]);

  useEffect(() => {
    if (formData?.city) {
      getHubAPI(formData?.city);
    }
  }, [formData?.city]);

  const workorderfields = [
    {
      label: "City",
      value: "city",
      type: "select",
      subCategory:
        (cities && profile?.roles.includes(Number(catalogRoles))) ||
        profile?.actions.includes(Number(catalogRActions))
          ? [{ label: cities[profile?.cityId], value: profile?.cityId }]
          : Object.entries(cities).map(([key, value]) => ({
              label: value,
              value: key,
            })),
      text: null,
      labelValue: null,
    },
    {
      label: "Hub",
      value: "hub",
      type: "dropdown",
      subCategory:
        hubs &&
        Object.entries(hubs).map(([id, item]) => ({
          value: item?.id,
          label: item?.hubName,
        })),
      text: null,
      labelValue: null,
    },
    {
      label: "Vehicle",
      value: "vehicle",
      type: "autocomplete",
      subCategory:
        vehicleList &&
        Object.entries(vehicleList).map(([id, item]) => ({
          value: { id: item?.id, vehcileNo: item?.licensePlate },
          label:
            item?.name +
            "_" +
            item?.licensePlate +
            "_" +
            item?.status +
            "_" +
            item?.vehicleGroupText,
        })),
      text: null,
      labelValue: null,
    },
    {
      label: "Workorder Type",
      value: "workordertype",
      type: "dropdown",
      subCategory:
        workorderType &&
        Object.entries(workorderType).map(([key, value]) => ({
          label: value,
          value: key,
        })),
      text: null,
      labelValue: null,
    },
    ...(workorderType?.[formData?.workordertype] === "Wear And Tear"
    ? [
        {
          label: "Sub Workorder Type",
          value: "subWorkordertype",
          type: "dropdown",
          subCategory: [
            { label: "Clutch", value: "Clutch" },
            { label: "Wind Shield", value: "Wind Shield" },
            { label: "Tyres", value: "Tyres" },
            { label: "Battery", value: "Battery" },
            {
              label: "Wheel Alignment / Balancing",
              value: "Wheel Alignment / Balancing",
            },
          ],
          text: null,
          labelValue: null,
        },
      ]
    : []),
    // {
    //   label: "Workorder Status",
    //   value: "workorderstatus",
    //   type: "dropdown",
    //   subCategory:
    //     workorderStatus &&
    //     Object.entries(workorderStatus).map(([key, value]) => ({
    //       label: value,
    //       value: key,
    //     })),
    //   text: null,
    // },
    // {
    //   label: "Repair Priority",
    //   value: "repairpriority",
    //   type: "dropdown",
    //   subCategory:
    //     helpdeskTicketPriority &&
    //     Object.entries(helpdeskTicketPriority).map(([key, value]) => ({
    //       label: value,
    //       value: key,
    //     })),
    //   text: null,
    // },
    // {
    //   label: "Reporting Date",
    //   value: "reportingdate",
    //   type: "date",
    //   text: null,
    // },
    // {
    //   label: "Scheduled Date",
    //   value: "scheduleddate",
    //   type: "date",
    //   text: null,
    // },
    {
      label: "Odometer (KM)",
      value: "odometer",
      type: "number",
      text: null,
      labelValue: null,
    },
    {
      label: "Odometer Image",
      value: "odometerimage",
      type: "file",
      text: null,
      labelValue: null,
    },
    // {
    //   label: "Assigned To",
    //   value: "assignedto",
    //   type: "select",
    //   subCategory:
    //     isSystemUserList &&
    //     Object.entries(isSystemUserList).map(([id, item]) => ({
    //       value: { id: item?.id, email: item?.email, mobile: item?.mobile },
    //       label: item?.name + "_" + item?.email + "_" + item?.mobile,
    //     })),
    //   text: null,
    // },
    // {
    //   label: "Vendor",
    //   value: "vendor",
    //   type: "select",
    //   subCategory:
    //     vendorList &&
    //     Object.entries(vendorList).map(([id, item]) => ({
    //       value: item?.id,
    //       label:
    //         item?.name + "_" + item?.contactMobile + "_" + item?.contactEmail,
    //     })),
    //   text: null,
    // },
    {
      label: "Other Attachments",
      value: "otherattachments",
      type: "file",
      text: null,
      labelValue: null,
    },
  ];

  const workorderblockfields = [
    {
      label: "Start Date",
      value: "startDate",
      type: "date",
      subCategory: null,
      text: null,
    },
    {
      label: "Start Time",
      value: "startTime",
      type: "time",
      subCategory: null,
      text: null,
    },
    {
      label: "End Date",
      value: "endDate",
      type: "date",
      subCategory: null,
      text: null,
    },
    {
      label: "End Time",
      value: "endTime",
      type: "time",
      subCategory: null,
      text: null,
    },
  ];

  const renderField = (field, formData, setFormData) => {
    const handleChange = (key, value) => {
      setFormData((prev) => ({
        ...prev,
        [key]: value,
      }));
      setErrors((prev) => ({
        ...prev,
        [key]: "",
      }));
    };

    switch (field.type) {
      case "text":
        // case "date":
        return (
          <>
            <TextField
              type={field.type}
              fullWidth
              size="small"
              value={formData[field.value] || ""}
              onChange={(e) => handleChange(field.value, e.target.value)}
              InputLabelProps={field.type === "date" ? { shrink: true } : {}}
              error={!!errors[field.value]}
              helperText={errors[field.value]}
            />
          </>
        );

      case "number":
        // case "date":
        return (
          <>
            <TextField
              type={field.type}
              fullWidth
              size="small"
              value={formData[field.value] || ""}
              onChange={(e) => handleChange(field.value, e.target.value)}
              InputLabelProps={field.type === "date" ? { shrink: true } : {}}
              error={!!errors[field.value]}
              helperText={errors[field.value]}
            />

            <p className="text-xs text-blue-800 font-bold">
              Current odometer -{" "}
              {vehicleList.filter(
                (vehicle) => vehicle?.id === formData?.vehicle?.id,
              )[0]?.currentOdometer + " / Km"}
            </p>
          </>
        );

      case "date":
        const today = new Date().toISOString().split("T")[0];

        const getMinDate = () => {
          if (field.value === "startDate") {
            return today;
          }

          if (field.value === "endDate") {
            if (formData.startDate) {
              const nextDay = new Date(formData.startDate);
              nextDay.setDate(nextDay.getDate() + 1);

              return nextDay.toISOString().split("T")[0];
            }
            return today; // fallback
          }

          return today;
        };

        return (
          <TextField
            type="date"
            fullWidth
            size="small"
            value={formData[field.value] || ""}
            onChange={(e) => handleChange(field.value, e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              min: getMinDate(),
            }}
            error={!!errors[field.value]}
            helperText={errors[field.value]}
          />
        );

      case "file":
        return (
          <>
            <input
              type="file"
              name={field.value}
              multiple
              onChange={(e) => {
                ImageHandler(e.target.files).then((res) => {
                  handleChange(field.value, res ? res?.uploaded : null);
                });
              }}
              className={`border rounded-md p-2 w-full ${
                errors[field.value] ? "border-red-500" : "border-gray-300"
              }`}
            />

            {errors[field.value] && (
              <p className="text-red-500 text-xs mt-1">{errors[field.value]}</p>
            )}
          </>
        );

      case "select":
      case "dropdown":
        return (
          <TextField
            select
            fullWidth
            size="small"
            value={formData[field.value] || ""}
            onChange={(e) => handleChange(field.value, e.target.value)}
            error={!!errors[field.value]}
            helperText={errors[field.value]}
          >
            {field.subCategory?.map((item, index) => (
              <MenuItem key={index} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </TextField>
        );

      case "autocomplete":
        return (
          <Autocomplete
            options={field.subCategory || []}
            getOptionLabel={(option) => option.label || ""}
            value={
              field.subCategory?.find(
                (opt) => opt.value?.id === formData[field.value]?.id,
              ) || null
            }
            onChange={(_, value) =>
              handleChange(field.value, value?.value || null)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                error={!!errors[field.value]}
                helperText={errors[field.value]}
              />
            )}
          />
        );

      case "time":
        return (
          <>
            <select
              // id={item.value}
              // name={item.value}
              value={formData[field.value] || ""}
              onChange={(e) => handleChange(field.value, e.target.value)}
              // disabled={item?.isEnable}
              className={`border border-gray-300 rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition h-11 w-full border rounded-md p-2 w-full ${
                errors[field.value] ? "border-red-500" : "border-gray-300"
              }`}
            >
              <option value="">Select time</option>
              {Array.from({ length: 48 }, (_, i) => {
                const hours = Math.floor(i / 2);
                const minutes = i % 2 === 0 ? "00" : "30";
                const time = `${String(hours).padStart(2, "0")}:${minutes}`;
                return (
                  <option key={time} value={time} className="py-1 text-sm flex">
                    {time}
                  </option>
                );
              })}
            </select>
            {errors[field.value] && (
              <p className="text-red-500 text-xs mt-1">{errors[field.value]}</p>
            )}
          </>
        );

      default:
        return null;
    }
  };

  const steps = [
    {
      label: "Work Order Details",
      content: (
        <>
          {workOrderReponse ? (
            <>
              <WorkOrderDetails
                data={{
                  code: workOrderReponse?.trackingId,
                  hub: workOrderReponse?.hubId,
                  type: workOrderReponse?.workorderType,
                  city: workOrderReponse?.cityId,
                  vehicle: workOrderReponse?.vehicleId,
                  priority: workOrderReponse?.priorityId,
                  reportingDate: workOrderReponse?.reportedOn,
                  startDate: workOrderReponse?.scheduledStartDate,
                }}
              />
            </>
          ) : (
            <>
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 my-4">
                  {workorderfields?.map((field, index) => (
                    <div key={index} className="my-4">
                      <label className="block mb-1 text-sm font-semibold">
                        {field.label}
                      </label>
                      {renderField(field, formData, setFormData)}
                    </div>
                  ))}
                </div>

                {/* <Box
                  sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}
                >
                  <Button type="submit" variant="contained">
                    Save & Continue
                  </Button>
                </Box> */}
              </form>

              {uploadedImages?.length > 0 && (
                <div className="grid grid-cols-1 bg-white p-4 rounded-lg">
                  {uploadedImages?.length > 0 ? (
                    <div className="mt-6 flex gap-4 flex-wrap">
                      {uploadedImages.map((image, index) => (
                        <img
                          key={index}
                          src={
                            image?.url ||
                            image?.Location ||
                            image?.path ||
                            image
                          }
                          alt="Image Preview"
                          className="w-28 h-28 rounded-lg object-cover border shadow"
                        />
                      ))}
                    </div>
                  ) : (
                    <div className="mt-6 flex gap-4 flex-wrap">
                      <img
                        src={uploadedImages}
                        alt="Image Preview"
                        className="w-28 h-28 rounded-lg object-cover border shadow"
                      />
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </>
      ),
    },
    {
      label: "Block Details",
      content: (
        <>
          <form>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 my-4">
              {workorderblockfields?.map((field, index) => (
                <div key={index} className="my-4">
                  <label className="block mb-1 text-sm font-semibold">
                    {field.label}
                  </label>
                  {renderField(field, blockFormData, setBlockFormData)}
                </div>
              ))}
            </div>

            {/* <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button type="submit" variant="contained">
                Submit
              </Button>
            </Box> */}
          </form>

          {bookingsOnBlock && (
            <>
              <div className="mt-12 p-4">
                <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                  Affected Bookings
                </h2>

                <div className="overflow-auto rounded-lg shadow bg-white">
                  <table className="min-w-full text-sm text-left shadow-lg border border-gray-100">
                    <thead className="">
                      <tr>
                        <th className="p-4">ID</th>
                        <th className="p-4">Booking Code</th>
                        <th className="p-4">Book From</th>
                        <th className="p-4">Book To</th>
                        <th className="p-4">Status</th>
                        <th className="p-4 text-right">Ticket Size</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookingsOnBlock?.length ? (
                        bookingsOnBlock?.map((data) => (
                          <tr
                            key={data?.id}
                            className="border-b hover:bg-gray-50"
                          >
                            <td className="p-4">{data?.id}</td>
                            <td className="p-4">{data?.bookingCode}</td>
                            <td className="p-4">{data?.bookFrom}</td>
                            <td className="p-4">{data?.bookTo}</td>
                            <td className="p-4">
                              {fleetBookingStatus[data?.bookingStatus]}
                            </td>
                            <td className="p-4 text-right">
                              {data?.costToCustomer}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center p-4 text-gray-500"
                          >
                            No affected bookings found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </>
      ),
    },
  ];

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-8xl mx-auto bg-white rounded-2xl shadow-lg p-6">
        {/* 🔹 Step Header */}
        <div className="flex items-center justify-between w-full mb-8">
          {steps.map((step, index) => (
            <div key={index} className="flex-1 flex items-center">
              {/* Step Circle */}
              <div className="flex items-center">
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full font-bold 
                ${
                  activeStep >= index
                    ? "bg-blue-600 text-white"
                    : "bg-gray-300 text-gray-600"
                }`}
                >
                  {index + 1}
                </div>

                {/* Step Label */}
                <p
                  className={`ml-3 font-medium ${
                    activeStep >= index ? "text-blue-600" : "text-gray-500"
                  }`}
                >
                  {step.label}
                </p>
              </div>

              {/* Line */}
              {index !== steps.length - 1 && (
                <div className="flex-1 h-[2px] bg-gray-300 mx-4"></div>
              )}
            </div>
          ))}
        </div>

        {/* 🔹 Step Content */}
        <div className="bg-gray-50 p-6 rounded-xl border">
          {steps[activeStep].content}
        </div>

        {/* 🔹 Footer Buttons */}
        <div className="flex justify-between mt-6">
          {/* <button
            disabled={activeStep === 0}
            onClick={() => setActiveStep((prev) => prev - 1)}
            className="px-5 py-2 rounded-lg border bg-white hover:bg-gray-100 disabled:opacity-50"
          >
            Back
          </button> */}

          {activeStep < steps.length - 1 ? (
            <button
              onClick={(e) => handleSubmit(e)}
              disabled={isSubmitting}
              className="px-6 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              Next
            </button>
          ) : (
            <button
              onClick={(e) => handleSubmit(e)}
              disabled={isSubmitting}
              className="px-6 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              Finish
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const WorkOrderDetails = ({ data }) => {
  const fields = [
    { label: "Workorder Code", key: "code" },
    { label: "Hub", key: "hub" },
    { label: "Workorder Type", key: "type" },
    { label: "City", key: "city" },
    { label: "Vehicle", key: "vehicle" },
    { label: "Repair Priority", key: "priority" },
    { label: "Reporting Date", key: "reportingDate" },
    { label: "Scheduled Start Date", key: "startDate" },
  ];

  return (
    <div className="bg-white shadow-lg rounded-2xl p-6 w-full max-w-3xl">
      <h1 className="text-2xl font-semibold text-gray-800 mb-6">
        Work Order Details
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {fields.map((item, index) => (
          <div
            key={index}
            className="bg-gray-50 rounded-xl p-4 hover:shadow-md transition"
          >
            <p className="text-xs text-gray-500 uppercase tracking-wide">
              {item.label}
            </p>
            <p className="text-lg font-medium text-gray-800 mt-1">
              {data?.[item.key] || "-"}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
